import {
    Box,
    Flex,
    Text,
    Button,
    Link,
    HStack,
    VStack,
    Divider,
    Spacer,
    Heading,
} from "@chakra-ui/react";
import { Image } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { nextStep } from '../../store/formSlice';
// import logo from "../assets/WebLogoMain.png"; // Adjust path as needed

export default function IntroStep() {
    const dispatch = useDispatch();

    const handleContinue = () => {
        dispatch(nextStep());
    };

    return (
        <Box minH="100vh" bg="#f6fbfd">
            {/* Stepper removed, now in FormContainer */}
            {/* Main Content */}
            <VStack spacing={6} textAlign="center" maxW="3xl" mx="auto" px={4}>

                <Heading variant="headline" w="80vw">
                    "Connection. Care. Cognitive Stimulation."
                </Heading>
                <Text variant="subtitle">
                    At Sophie Care, we provide personalized phone calls for{" "}
                    <Text as="span" variant="highlighted">
                        seniors
                    </Text>{" "}
                    designed to brighten their day,{" "}
                    <Text as="span" variant="highlighted">
                        reduce loneliness
                    </Text>
                    , and keep their minds active.
                </Text>
                <Text variant="subtitle">
                    Our trained companions offer friendly{" "}
                    <Text as="span" variant="highlighted">
                        conversations
                    </Text>
                    , memory{" "}
                    <Text as="span" variant="highlighted">
                        games
                    </Text>
                    , and engaging{" "}
                    <Text as="span" variant="highlighted">
                        discussions
                    </Text>
                    , while keeping families and caregivers informed with regular updates.
                </Text>
                <Button
                    mt={4}
                    px="30px"
                    onClick={handleContinue}
                >
                    Continue
                </Button>
            </VStack>
        </Box>
    );
}